export const imageCodes = {
    Qr: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fqr.png?alt=media&token=85b45242-adc5-4dc2-971f-13d99beec2c7"
    },
    
}

